import { render, staticRenderFns } from "./scrollUp.vue?vue&type=template&id=1e5b3d9c&"
import script from "./scrollUp.vue?vue&type=script&lang=js&"
export * from "./scrollUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e5b3d9c')) {
      api.createRecord('1e5b3d9c', component.options)
    } else {
      api.reload('1e5b3d9c', component.options)
    }
    module.hot.accept("./scrollUp.vue?vue&type=template&id=1e5b3d9c&", function () {
      api.rerender('1e5b3d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/scrollUp.vue"
export default component.exports